import type { ReactNode } from 'react';
import cn from 'classnames';

import Styles from './Layout.module.scss';

export interface ILayout {
  children?: ReactNode;
}

const Layout = ({ children = null }: ILayout) => {
  return (<div className={cn(Styles.container)}>{children}</div>);
};

export default Layout;
